import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class ModalMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || InAppMessage.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || InAppMessage.CropType.FIT_CENTER),
      void 0,
      k,
      q,
    ),
      (this.Te = InAppMessage.TextAlignment.CENTER);
  }
  tt() {
    return super.tt(ModalMessage.et);
  }
  static an(e) {
    return new ModalMessage(
      e[InAppMessage.it.ea],
      e[InAppMessage.it.ra],
      e[InAppMessage.it.jt],
      e[InAppMessage.it.sa],
      e[InAppMessage.it.ta],
      e[InAppMessage.it.URI],
      e[InAppMessage.it.ia],
      e[InAppMessage.it.oa],
      e[InAppMessage.it.pa],
      e[InAppMessage.it.ma],
      e[InAppMessage.it.nt],
      e[InAppMessage.it.na],
      e[InAppMessage.it.ua],
      e[InAppMessage.it.ca],
      e[InAppMessage.it.fa],
      e[InAppMessage.it.da],
      e[InAppMessage.it.la],
      e[InAppMessage.it.ga],
      e[InAppMessage.it.ja],
      e[InAppMessage.it.xa],
      e[InAppMessage.it.za],
      e[InAppMessage.it.ha],
      e[InAppMessage.it.va],
      pe(e[InAppMessage.it.wa]),
      e[InAppMessage.it.ya],
      e[InAppMessage.it.ba],
      e[InAppMessage.it.CSS],
    );
  }
}
ModalMessage.et = InAppMessage.qe.un;
